<template>
  <v-container fluid >
    <ExplorerHeader
      :title="context_title"
      :calendar_props="calendar_props"
      v-on:calendar-action="forwardCalendarAction"/>


    <div>
      <v-container
        v-if="current_view === 'ExplorerTable' && current_business_process === 'DOCISODEFAULT'"
        dense
        fluid
        class="pt-0 pb-0"
      >
        <v-row no-gutters>
          <v-col
            cols="2"
            class="pt-0 pb-0"
          >
            <ExplorerDirectory />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col class="pt-0 pb-0" overflow-x="auto" >
            <ExplorerTable/>
          </v-col>
        </v-row>
      </v-container>
      <ExplorerTable
        v-else-if="current_view === 'ExplorerTable'"
      />
    </div>

    <ExplorerCalendar
      v-if="current_view === 'ExplorerCalendar'"
      ref="calendar"
      v-on:update-calendar-props="updateCalendarProps"
    />
    <ExplorerReport v-if="current_view === 'ExplorerReport'"/>  
  </v-container>
</template>


<script>
 import { mapActions, mapMutations, mapState } from 'vuex'
 import ExplorerDirectory from './ExplorerDirectory'
 import ExplorerHeader from './ExplorerHeader'
 import ExplorerTable from './ExplorerTable'
 import ExplorerCalendar from './ExplorerCalendar'
 import ExplorerReport from './ExplorerReport'

 export default {
   name: 'Explorer',
   components: {
     ExplorerDirectory,
     ExplorerHeader,
     ExplorerTable,
     ExplorerCalendar,
     ExplorerReport,
   },
   data() {
     return {
       calendar_props: {},
     }
   },
   computed: mapState([
     'context_title',
     'current_view',
     'current_business_process',
   ]),
   methods: {
     forwardCalendarAction(action, ...args) {
       this.$refs.calendar[action](...args);
     },
     updateCalendarProps(props) {
       this.calendar_props = props;
     },
   },

 }
</script>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>
